import { IconsPopoverContent } from './IconsPopoverContent.main';

export { IconsPopoverContent };
